var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"28","height":"20","viewBox":"0 0 28 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10 1L1 10l9 9M1 10h26","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }